import { BrandType, Brand } from './brands'

function resolveBrandAlta(brand: BrandType) {
    return brand.id === (Brand.altasp.id || Brand.altarj.id) ? 'alta' : brand.mappingId
}

export const Paths = {
    home: '/inicio',
    laboratory: '/',
    landingPage: '/:brand',
    notFound: '/nao-encontrado',
    errorPage: '/sessao-expirada',
    noAuthorized: '/nao-autorizado',
    connFailed: '/erro-de-conexao',
    unsuportedBrowser: '/navegador-nao-suportado',
    outdatedBrowser: '/navegador-desatualizado',
    onLoadError: '/erro-ao-carregar',
    somethingWrong: '/erro',
    redirectExamByBrand: '/login?redirectTo=/v2/agd-exames/paciente?brandId%3D',
    redirectVaccnicesByBrand: '/login?redirectTo=/v2/vacinas/paciente?brandId%3D',
    landingPageBrand: '/:brand',
    landingPageProduct: '/:brand/:productId/:productName',
    redirectExamByBrandAndProducts: (brand: BrandType, productIds: number | number[], tagging?: string): string => {
        const path = `/entrar?laboratorio=${resolveBrandAlta(brand)}&redirectTo=/agd-exames/paciente&brandId=${
            brand.id
        }&productIds=${productIds.toString()}`
        return tagging ? `${path}&${tagging}` : path
    },
    redirectVaccnicesByBrandAndProducts: (brand: BrandType, productIds: number | number[], tagging?: string): string => {
        const path = `/entrar?laboratorio=${resolveBrandAlta(brand)}&redirectTo=/vacinas/paciente&brandId=${
            brand.id
        }&productIds=${productIds.toString()}`
        return tagging ? `${path}&${tagging}` : path
    },
}
